/*
    Тогглер компонента демо-формы
    Выводит список опций в виде тоггера, при выборе опции обновляет modelValue
*/

import demoButton from "./demo-form-button";

const template = /* html */`
    <div class="demo-form-toggler flex">
        <demo-button
            v-for="option in options"
            :key="option.id"
            :active="option.id === activeID"
            :class="['flex-1', option.goalName && 'js-goal']"
            @click="$emit('update:modelValue', option.id)"
            :rounded="false"
            transparent
            :data-test="option.id"
            :data-source="option.goalName || null"
        >
            [[ option.text ]]
        </demo-button>
    </div>
`;

export default {
    name: "DemoFormToggler",
    template,
    props: {
        modelValue: {
            type: String,
            default: "",
        },
        options: {
            type: Object,
            required: true,
        },
    },
    emits: ["update:modelValue"],
    computed: {
        activeID() {
            if (this.modelValue) return this.modelValue;
            return this.options[0].id;
        },
    },
    components: { demoButton },
};
